import type {APIUser} from "~/types/user";

export const getNavLinks = (user: APIUser) => ([
    {
        to: '/' + user?.username,
        name: 'Profile',
        image: user?.image_url
    },
    {
        to: '/',
        icon: 'mingcute:home-1-line',
        iconActive: 'mingcute:home-1-fill',
        name: 'Feed'
    },
    {
        to: '/upload',
        icon: 'mdi:post-it-note-edit',
        name: 'Post',
    },
    {
        to: '/settings',
        icon: 'i-mynaui:cog-two-solid',
        name: 'Settings'
    }
])
